import { StyleSheet } from "react-native";
import { color2 } from "src/styles/colors";
import { font } from "src/styles/themes";
import { dpToPx } from "src/styles";

export const baseStyles = () =>
  StyleSheet.create({
    headline: {
      color: color2.BLUE_DARK,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.header,
      lineHeight: dpToPx(40),
    },
    caption: {
      color: color2.GRAY4,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.caption,
      lineHeight: dpToPx(24),
    },
    receiptHeadline: {
      color: color2.BLUE_DARK,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.titleText,
    },
    receiptCaption: {
      color: color2.BLUE_DARK,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.receiptCaption,
    },
    inputTextField: {
      color: color2.BLUE_DARK,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.input,
    },
    titleText: {
      color: color2.BLUE_DARK,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.titleText,
      lineHeight: dpToPx(19),
    },
    subtitleText: {
      color: color2.GRAY4,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.subtitleText,
      lineHeight: dpToPx(15),
    },
  });
